import React from 'react';
import styles from './CeldaOrdenable.module.css';

/**
 * Componente reutilizable para celdas de encabezado ordenables con soporte multi-nivel
 * @param {string} campo - identificador del campo
 * @param {string} label - texto a mostrar
 * @param {Array} ordenamientos - array de {campo, ascendente} ordenamientos activos (ordenados por prioridad)
 * @param {function} onChange - callback(nuevosOrdenamientos) cuando se cambia ordenamiento
 * @param {string} className - clases CSS adicionales para la celda
 * @param {string} title - tooltip al pasar el mouse
 */
const CeldaOrdenable = ({
  campo,
  label,
  ordenamientos = [],
  onChange,
  className,
  title = 'Click: principal asc/desc/off. Shift+Click: secundario asc/desc/off',
}) => {
  // Encontrar si este campo ya está en el ordenamiento
  const indiceOrdenamiento = ordenamientos.findIndex((o) => o.campo === campo);
  const estaActivo = indiceOrdenamiento !== -1;
  const esAscendente = estaActivo ? ordenamientos[indiceOrdenamiento].ascendente : true;

  const icono = estaActivo ? (esAscendente ? ' ▲' : ' ▼') : '';

  const handleClick = (e) => {
    let nuevosOrdenamientos = [...ordenamientos];

    if (e.shiftKey) {
      // Shift+Click: ciclo de estados para ordenamiento secundario
      if (estaActivo) {
        if (esAscendente) {
          // Estado 1 (▲) → Estado 2 (▼)
          nuevosOrdenamientos[indiceOrdenamiento].ascendente = false;
        } else {
          // Estado 2 (▼) → Estado 0 (sin ordenamiento)
          nuevosOrdenamientos.splice(indiceOrdenamiento, 1);
        }
      } else {
        // Estado 0 → Estado 1 (▲): Agregar al final como ordenamiento secundario
        nuevosOrdenamientos.push({ campo, ascendente: true });
      }
    } else {
      // Click normal: ciclo de estados para ordenamiento principal
      if (estaActivo) {
        if (esAscendente) {
          // Estado 1 (▲) → Estado 2 (▼)
          nuevosOrdenamientos[indiceOrdenamiento].ascendente = false;
          // Mover al inicio (principal)
          const item = nuevosOrdenamientos.splice(indiceOrdenamiento, 1)[0];
          nuevosOrdenamientos.unshift(item);
        } else {
          // Estado 2 (▼) → Estado 0 (sin ordenamiento)
          nuevosOrdenamientos.splice(indiceOrdenamiento, 1);
        }
      } else {
        // Estado 0 → Estado 1 (▲): Agregar al inicio como principal
        nuevosOrdenamientos.unshift({ campo, ascendente: true });
      }
    }

    onChange(nuevosOrdenamientos);
  };

  return (
    <td
      className={`${styles.celdaOrdenable} ${className || ''}`}
      onClick={handleClick}
      title={title}
      style={{ cursor: 'pointer' }}
    >
      <strong>
        {label}
        <span className={styles.icono}>{icono}</span>
      </strong>
    </td>
  );
};

export default CeldaOrdenable;
